/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PriceType {
    LAST_PRICE = 'LastPrice',
    BEST_BID = 'BestBid',
    BEST_ASK = 'BestAsk',
}
